import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const Packaging = () => <ProductDetailPage {...getProductPageConfig('packaging')} />;

export default Packaging;
